const checkoutTemplate = require('../../checkout/views/checkout.view.html').trim(),
    centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('checkoutroot', {
            abstract: true,
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('checkout');
                    },
                ],
            },
            views: {
                '@': {
                    template: checkoutTemplate,
                },
            },
            data: {
                authenticate: true,
            },
        })
        // Have you forgotten
        .state('hyf', {
            url: '^/shop/checkout',
            parent: 'checkoutroot',
            onEnter: ['CheckoutStepService', (checkoutStepService) => {
                checkoutStepService.currentStep = 'hyf';
            }],
            views: {
                'checkout-content@checkoutroot': {
                    controller: ['$state', 'HaveYouForgottenService', 'FeatureService', function ($state, haveYouForgottenService, featureService) {
                        if (featureService.isEnabled(featureService.features.rrShowPlacementsInHyfPages)) {
                            this.products = {};
                        } else {
                            haveYouForgottenService.getProducts().then((response) => {
                                if (!response.length) {
                                    $state.go('checkout', null, { location: 'replace' });
                                }
                            });
                        }
                    }],
                    template: '<wow-have-you-forgotten></wow-have-you-forgotten>',
                    resolve: {
                        skipHaveYouForgottenSettings: [
                            '$state', 'SettingsByBreakpointService', function ($state, settingsByBreakpointService) {
                                const shouldSkipHaveYouForgotten = settingsByBreakpointService.getSettingValueByBreakpoint('OneSite', {
                                    largeFormat: 'SkipHaveYouForgottenLargeFormatEnabled',
                                    mediumFormat: 'SkipHaveYouForgottenMediumFormatEnabled',
                                    smallFormat: 'SkipHaveYouForgottenSmallFormatEnabled',
                                });

                                if (shouldSkipHaveYouForgotten) {
                                    $state.go('checkout', null, { location: 'replace' });
                                }
                            },
                        ],
                    },
                },
                'rr-instrumentation-panel@checkoutroot': {
                    template: '<wow-rr-generic-instrumentation page-group="Hyf" placement-ids="generic_page.have_you_forgotten"></wow-rr-generic-instrumentation>',
                },
            },
            data: {
                pageMetadata: {
                    title: 'Have You Forgotten',
                    metaDescription: 'Have You Forgotten',
                },
            },
        })
        // Conversational Checkout Wizard routes
        .state('checkout', {
            url: '/checkout',
            parent: 'checkoutroot',
            views: {
                'checkout-content@checkoutroot': {
                    template: '<wow-checkout-wizard></wow-checkout-wizard>',
                },
            },
            onEnter: [
                'CheckoutStepService', function (checkoutStepService) {
                    if (checkoutStepService.canReviewOrder()) {
                        checkoutStepService.setCurrentStep('review');
                    } else {
                        checkoutStepService.setCurrentStep('delivery');
                    }
                },
            ],
            data: {
                pageMetadata: {
                    title: 'Checkout - Woolworths Online',
                    metaDescription: 'Checkout - Woolworths Online',
                },
            },
        })
        .state('shop.confirmation', {
            url: '/confirmation?orderId&saveCard',
            resolve: {
                orderConfirmation: [
                    '$ocLazyLoad', '$injector', '$stateParams', function ($ocLazyLoad, $injector, $stateParams) {
                        return $ocLazyLoad.load('checkout').then(() => {
                            const checkoutService = $injector.get('CheckoutService');
                            return checkoutService.getOrderConfirmation($stateParams.orderId);
                        });
                    },
                ],
                rewardsActivationGuid: [
                    // Needed to load wow-my-rewards-plus-offer-link (dynamic content)
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('myaccount');
                    },
                ],
            },
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'rr-instrumentation-panel@root': {
                    controller: ['$scope', 'orderConfirmation', function ($scope, orderConfirmation) {
                        $scope.order = orderConfirmation.Order;
                    }],
                    template: '<wow-rr-purchased-instrumentation order="order"></wow-rr-purchased-instrumentation>',
                },
                'center-panel@shop.confirmation': {
                    controller: [
                        '$stateParams', 'orderConfirmation', function ($stateParams, orderConfirmation) {
                            this.orderConfirmation = orderConfirmation;
                            this.isSaveCard = Boolean($stateParams.saveCard);
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-order-confirmation-panel order="$ctrl.orderConfirmation" save-card="$ctrl.isSaveCard"></wow-order-confirmation-panel>',
                },
            },
            data: {
                authenticate: true,
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/checkout.js